export { default } from "./PowerWordQuizSummary";
